import { Socket } from "phoenix";
import Cookies from 'universal-cookie';
const cookies = new Cookies()

//Socket local
// let socket = new Socket("ws://localhost:4001/socket", { params: {token: cookies.get("goto_socket")} });

//Socket Server
let socket = new Socket("/socket", { params: { token: cookies.get("goto_socket") } });

if (cookies.get("goto_socket")) {

  socket.connect();

} else {

  socket.disconnect();

}

export default socket;
